<template>
  <div id="weeklyReport" element-loading-background="rgba(255, 255, 255, 0.4)">
    <div style="padding-bottom: 10px">
      <el-button type="primary" size="small" @click="openHistoryDialog">Historical Weekly Report</el-button>
      <el-button type="primary" size="small" v-if="allData && allData.projectStatus !== 6 && allData.projectStatus !== 5" @click="openRecipientDialog()" >Send Weekly Report</el-button>
    </div>
    <el-form :model="weeklyReportForm" ref="weeklyReportForm" label-width="190px">
      <el-collapse v-model="activeNames">
        <el-collapse-item title="Basic Information of Project " name="1">
          <el-row>
            <el-col :span="0">
              <el-form-item prop="id">
                <el-input  v-model="weeklyReportForm.id" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" :xl="6">
              <el-form-item label="Project Manager:" prop="projectManager">
                <el-select
                  v-model="weeklyReportForm.projectManager"
                  clearable
                  filterable
                  remote
                  disabled
                >
                  <el-option v-for="(item, index) in projectManagerList" :key="index" :label="item.empName + ' ' + item.empCode" :value="item.empCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" :xl="6">
              <el-form-item label="Technical Manager:" prop="developmentLeader">
                <el-select
                  v-model="weeklyReportForm.developmentLeader"
                  clearable
                  filterable
                  remote
                  disabled
                >
                  <el-option v-for="(item, index) in developmentLeaderList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" :xl="6">
              <el-form-item label="Major Project Level:" prop="majorProjectLevel">
                <el-select clearable v-model="weeklyReportForm.majorProjectLevel" disabled>
                  <el-option
                    v-for="item in majorProjectLevel"
                    :key="item.labelKey"
                    :label="item.labelValue"
                    :value="item.labelKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" :xl="6">
              <el-form-item label="Sub Industry:" prop="customerIndustry">
                <el-select clearable v-model="weeklyReportForm.customerIndustry" disabled>
                  <el-option
                    v-for="item in customerIndustry"
                    :key="item.labelKey"
                    :label="item.labelValue"
                    :value="item.labelKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="Project Overview:" prop="projectSurvey" :rules="[{ required: true, message: 'Please input'}]">
                <el-input type="textarea" clearable v-model="weeklyReportForm.projectSurvey" maxlength="1000" placeholder="Please input" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="Overall Project Progress" name="2">
          <el-row>
            <el-col :span="24">
              <el-form-item label="Overall Project Progress:" prop="overallProgress" :rules="[{ required: true, message: 'Please input'}]">
                <el-input type="textarea" clearable v-model="weeklyReportForm.overallProgress" maxlength="1000" placeholder="Please input" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="Project Health, Risks & Issues and Reponse Measures" name="3">
          <el-row>
            <el-col :span="12">
              <el-form-item label="Project Overall Health:" prop="riskLevel">
                <el-select clearable v-model="weeklyReportForm.riskLevel" placeholder="Please select" disabled
                :class="weeklyReportForm.riskLevel === 1 ? 'redbg' :weeklyReportForm.riskLevel === 2 ? 'yellowbg' : weeklyReportForm.riskLevel === 3 ? 'greenbg' :''">
                  <el-option
                    v-for="item in riskLevel"
                    :key="item.labelKey"
                    :label="item.labelValue"
                    :value="item.labelKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-table :data="weeklyReportForm.riskList" :cell-style="cellStyle" border size="small" style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
            <el-table-column prop="riskTypeDesc" label="Risk Type"></el-table-column>
            <el-table-column prop="riskLevelDesc" label="Risk Level" align="center"></el-table-column>
            <el-table-column prop="riskDesc" label="Risk Description"></el-table-column>
            <el-table-column prop="responseMeasures" label="Response Measures"></el-table-column>
            <el-table-column prop="personResponsible" label="Owner"></el-table-column>
            <el-table-column prop="plannedClosingTime" label="Planned Closing Date">
              <template v-slot="scope">
                {{ scope.row.plannedClosingTime ? moment(scope.row.plannedClosingTime).format('YYYY-MM-DD') : ''}}
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item title="Weekly Progress" name="4">
          <el-row>
            <el-col :span="12">
              <el-form-item label="Weekly Report Period:" prop="weeklyStartEndDate" :rules="[{ required: true, message: 'Please input' }]">
                <el-date-picker
                  v-model="weeklyReportForm.weeklyStartEndDate"
                  type="daterange"
                  range-separator="-"
                  start-placeholder=""
                  end-placeholder=""
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Project Duration:" prop="projectStartEndDate">
                <el-date-picker
                  v-model="weeklyReportForm.projectStartEndDate"
                  type="daterange"
                  range-separator="-"
                  start-placeholder=""
                  end-placeholder=""
                  disabled
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-table :data="weeklyReportForm.thisWeekWorkProgressList" border class="week-table" size="small" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
            <el-table-column label=""  width="50">
              <template v-slot="scope">
                <i class="el-icon-circle-plus-outline" style="font-size: 20px; margin-top: 2px;" @click="addRow(scope.$index, 'thisWeekWorkProgressList')"></i>
                <i class="el-icon-remove-outline" style="font-size: 20px;; margin-top: 2px;" @click="deleteRow(scope.$index, 'thisWeekWorkProgressList')" v-if="scope.$index !== 0"></i>
              </template>
            </el-table-column>
            <el-table-column label="No." type="index" sortable width="85" align="center"></el-table-column>
            <el-table-column prop="jobContent" align="center">
              <template slot="header">
                <span class="hasStar">Work Completed<span>*</span></span>
              </template>
              <template slot-scope="scope">
                <el-form-item  :prop="'thisWeekWorkProgressList.' + scope.$index + '.jobContent'"  :rules="{ required: true, message: 'Please input' }" label-width="0">
                  <el-input type="textarea" v-model="scope.row.jobContent" maxlength="1000" clearable :title="scope.row.jobContent" placeholder="Please input" />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item title="Next Week Plan" name="5">
          <el-table :data="weeklyReportForm.nextWeekWorkProgressList" border class="week-table" size="small" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
            <el-table-column label=""  width="50">
              <template v-slot="scope">
                <i class="el-icon-circle-plus-outline" style="font-size: 20px; margin-top: 2px;" @click="addRow(scope.$index, 'nextWeekWorkProgressList')"></i>
                <i class="el-icon-remove-outline" style="font-size: 20px;; margin-top: 2px;" @click="deleteRow(scope.$index, 'nextWeekWorkProgressList')" v-if="scope.$index !== 0"></i>
              </template>
            </el-table-column>
            <el-table-column label="No." type="index" sortable width="85" align="center"></el-table-column>
            <el-table-column prop="jobContent" align="center">
              <template slot="header">
                <span class="hasStar">Work Contents<span>*</span></span>
              </template>
              <template slot-scope="scope">
                <el-form-item  :prop="'nextWeekWorkProgressList.' + scope.$index + '.jobContent'"  :rules="{ required: true, message: 'Please input' }" label-width="0">
                  <el-input type="textarea" v-model="scope.row.jobContent" maxlength="1000" clearable :title="scope.row.jobContent" placeholder="Please input" />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item title="Project Milestone" name="6">
          <el-table :data="weeklyReportForm.milestoneList" border size="small" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
            <el-table-column label="Key Milestone" prop="criticalMilestone" min-width="45">
              <template v-slot="scope">
                {{ scope.row.criticalMilestone === 1 ? 'Yes' : scope.row.criticalMilestone === 0 ? 'No' : '' }}
              </template>
            </el-table-column>
            <el-table-column label="Key Task" prop="missionCritical" min-width="45"></el-table-column>
            <el-table-column label="Key Task Description" prop="missionCriticalDesc" min-width="45"></el-table-column>
            <el-table-column label="Progress Percentage (%)" prop="progressRatio" min-width="45"></el-table-column>
            <!-- <el-table-column label="Risk Level" prop="riskLevelDesc" min-width="45"></el-table-column> -->
            <el-table-column label="Current Status" prop="statusDesc" min-width="45"></el-table-column>
            <el-table-column label="Start Date" prop="startTime" min-width="45">
              <template v-slot="scope">
                {{ scope.row.startTime ? moment(scope.row.startTime).format('YYYY-MM-DD') : ''}}
              </template>
            </el-table-column>
            <el-table-column label="End Date" prop="endTime" min-width="45">
              <template v-slot="scope">
                {{ scope.row.endTime ? moment(scope.row.endTime).format('YYYY-MM-DD') : ''}}
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
      <div style="text-align: center; padding-top: 10px">
        <el-button type="primary" size="small" :loading="confirmLoading" v-if="allData && allData.projectStatus !== 5" @click="confirmWeekly('confirmLoading')">Save</el-button>
      </div>
    </el-form>
    <history-dialog ref="historyDialog" :id="id" />
    <el-dialog
			title="Email Address for Sending Project Weekly Report"
			width="855px"
			top="5vh"
			:visible.sync="recipientModal"
			:close-on-click-modal="false"
			:destroy-on-close="true"
			@closed="closeRecipientDialog"
		>
      <el-form :model="recipientForm" ref="recipientForm" label-width="120px" class="recipientForm">
        <!-- <p style="font-weight: 700; font-size: 13px;padding: 0 8px 14px 20px;margin-top: -20px;color: red;line-height: 21px;word-break:break-word;">
          <i class="el-icon-warning-outline" style="font-size: 16px" />
          The recipients and CC recipients of the weekly report are imported from the project appointment. If you want to add or modify recipients and CC recipients, please enter the recipients and cc recipients directly, separated by semicolon (;)  (English input method).	
        </p> -->
        <el-form-item prop="address" label="Recipient:" :rules="[{ required: true, message: 'Please input'}]">
          <el-input type="textarea" disabled v-model="recipientForm.address" maxlength="2000" :rows="6" placeholder="Please input" />
          <i class="el-icon-user-solid" style="font-size: 18px; position: absolute; right: 9px; top: 8px; cursor: pointer;" @click="openUserDialog(1)" />
        </el-form-item>
        <el-button style="margin: 0 0 20px 120px;" type="primary" size="small" @click="clearInfo('address')">Clear All</el-button>
        <el-form-item prop="cc" label="CC Recipient:" :rules="[{ required: true, message: 'Please input'}]">
          <el-input type="textarea" disabled v-model="recipientForm.cc" maxlength="2000" :rows="6" placeholder="Please input" />
          <i class="el-icon-user-solid" style="font-size: 18px; position: absolute; right: 9px; top: 8px; cursor: pointer;" @click="openUserDialog(2)" />
        </el-form-item>
        <el-button style="margin: 0 0 20px 120px;" type="primary" size="small" @click="clearInfo('cc')">Clear All</el-button>
      </el-form>
      <div style="text-align: right">
        <el-button size="small" @click="closeRecipientDialog()" :loading="sendLoading">Cancel</el-button>
        <el-button type="primary" size="small" @click="sendWeekly()" :loading="sendLoading">Confirm</el-button>
      </div>
		</el-dialog>
    <el-dialog
      class="user-dialog"
			title="选择人员/群组"
			width="1200px"
			top="5vh"
			:visible.sync="userDialog"
			:close-on-click-modal="false"
			:destroy-on-close="true"
			@closed="closeUserDialog"
		>
      <el-form label-width="110px">
        <el-row>
					<el-col :span="10">
            <el-form-item label="Keyword:">
              <el-input clearable="" v-model="searchUserWord" maxlength="2000" placeholder="Please input" />
            </el-form-item>
          </el-col>
					<el-col :span="12">
            <el-button style="margin: 4px 0 0 0px;" type="primary" size="small" @click="handleUserSearch('btn')">Search</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-col :span="15">
          <el-table :data="userTableData" v-loading="tableLoading" style="width: 100%" border size="small" ref="multipleTable" @selection-change="handleSelectionChange">
            <el-table-column type="selection"  width="55"></el-table-column>
            <el-table-column prop="empCode" label="User ID"  width="90" align="center" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{scope.row.empCode === null ? '-' : scope.row.empCode}}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="User/Group" width="150" align="center" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{scope.row.name === null ? '-' : scope.row.name}}
              </template>
            </el-table-column>
            <el-table-column prop="email" label="Email" align="center" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{scope.row.email === null ? '-' : scope.row.email}}
              </template>
            </el-table-column>
            <el-table-column prop="dept" label="Department" width="120" align="center" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{scope.row.dept === null ? '-' : scope.row.dept}}
              </template>
            </el-table-column>
            <el-table-column prop="type" label="Type" width="100" align="center" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{scope.row.type === null ? '-' : scope.row.type}}
              </template>
            </el-table-column>
          </el-table>
          <div class="pageDiv" style="padding: 20px 0 0 6px">
            <el-pagination
              small
              layout="total, prev, pager, next, sizes, jumper"
              :page-sizes="[5]"
              :current-page="userCurrentPage"
              :page-size="userPageSize"
              :total="userTotalCount"
              @size-change="changeUserPageSize"
              @current-change="changeUserPage"
            >
            </el-pagination>
          </div>
        </el-col>
        <el-col :span="1">
          <div class="transicon" @click="transferToChoosed()">
            <i class="el-icon-arrow-right" style="font-size: 18px;" />
          </div>
        </el-col>
        <el-col :span="6">
          <div class="choosed-user-wrap">
            <div v-for="(item, index) in choosedUserList" :key="item" :class="{ selected: item === selectedUserEmail }">
              <p @click="selectedUserEmail = item">{{ item }}</p>
              <i class="el-icon-remove-outline" @click="deleteItem(index, item) "/>
            </div>
          </div>
          <el-button type="primary" size="small" style="margin: 15px 0 0 84px" @click="submitChoosedUser()">Confirm</el-button>
        </el-col>
        <el-col :span="2">
          <div class="choosed-user-move">
            <span @click="moveUp" :disabled="!selectedUserEmail">Move Up</span>
            <span @click="moveDown" :disabled="!selectedUserEmail">Move Down</span>
          </div>
        </el-col>
      </el-row>
		</el-dialog>
  </div>
</template>
<script>
import moment from 'moment';
import historyDialog from './history.vue'
  export default {
    name: 'weeklyReport',
		components: {
      historyDialog,
		},
		props: {
			id: {
        type: Number,
        default: null,
      },
      allData: {
				type: Object,
        default: {},
			},
		},
		watch: {
		},
    created () {
      this.getSelectInfo();
      // this.getWeeklyInfo();
    },
    data () {
      return {
        moment,
        activeNames: ['1', '2', '3', '4', '5', '6'],
        weeklyReportForm: {},
        projectManagerList: [],
        majorProjectLevel: [],
        customerIndustry: [],
        developmentLeaderList: [],
        riskLevel: [],
        riskData: [],
        ganttDta: [],
        confirmLoading: false,
        sendLoading: false,
        recipientModal: false,
        addressData: '',
        ccData: '',
        recipientForm: {
          address: '',
          cc: '',
        },
        userChoosedType: '',
        userDialog: false,
        searchUserWord: '',
        tableLoading: false,
        userTableData: [],
        userCurrentPage: 1,
				userPageSize: 5,
        userTotalCount: 0,
        multipleSelection: [],
        selectedUserEmail: '',
        choosedUserList: [],
        fixedCcList: [],
      }
    },
    methods: {
			cellStyle({ row, column, rowIndex, columnIndex }) {
      // 根据某个条件来判断，例如这里根据 score 给单元格着色
				if (column.property === 'riskLevelDesc') {
					if (row.riskLevel === 1) {
						return { backgroundColor: '#FF0000' }; // 红色
					} else if (row.riskLevel === 2) {
						return { backgroundColor: '#FFFF00' }; // 红色
					} else if (row.riskLevel === 3) {
						return { backgroundColor: '#92D050' }; // 红色
					} 
				}
				return {};
			},
			getWeeklyInfo() {
        let url =`${this.$store.state.islhurl}majorProjectWeeklyReport/getByMajorProjectId?majorProjectId=${this.id}&&islhToken=${sessionStorage.getItem('islhtoken')}`;
        this._post(url).then(
          res => {  
            if(res && res.data) {
              const data = res.data;
              let nextWeekWorkProgressListNew = [];
              let thisWeekWorkProgressListNew = [];
              data.nextWeekWorkProgressList && data.nextWeekWorkProgressList.forEach(item => {
                nextWeekWorkProgressListNew.push({
                  jobContent: item,
                })
              })
              data.thisWeekWorkProgressList && data.thisWeekWorkProgressList.forEach(item => {
                thisWeekWorkProgressListNew.push({
                  jobContent: item,
                })
              })
              this.weeklyReportForm = {
                ...res.data,
                nextWeekWorkProgressList: nextWeekWorkProgressListNew.length === 0 ? [{}] : nextWeekWorkProgressListNew,
                thisWeekWorkProgressList: thisWeekWorkProgressListNew.length === 0 ? [{}] : thisWeekWorkProgressListNew,
                projectStartEndDate: [data.projectPlanStartDate, data.projectPlanEndDate],
                weeklyStartEndDate: data.reportStartDate ? [data.reportStartDate, data.reportEndDate] : [],
              }
              this.recipientForm = {
                address: res.data.addresseeList ? res.data.addresseeList.join(';') : '',
                cc: res.data.ccList ? res.data.ccList.join(';') : '',
              }
              this.addressData = res.data.addresseeList;
              this.ccData = res.data.ccList;
              this.fixedCcList = res.data.fixedCcList || [];
              this.ensureProtectedCC();
              this.$nextTick(() => {
                this.$refs.weeklyReportForm.clearValidate();
              });
            }
          }
        )
			},
			getSelectInfo() {
				let url = `${this.$store.state.islhurl}configMain/queryLabelList?`;
				let configKeyList = [
					'majorProjectLevel',
					'customerIndustry',
          'riskLevel',
				]
				let str = '';
				configKeyList.forEach(item => {
					str += `&configKeyList=${item}`;
				})
				url = url + str.substring(1)
				const _this = this
				this._post(url).then(
					res => {
						if (res.data && res.code === 200) {
							Object.keys(res.data).forEach(function(key) {
								_this[key] = res.data[key];
							});
						}
					}
				)
			},
      addRow(index, name) {
				this.weeklyReportForm[name].splice(index + 1, 0, {});
      },
			deleteRow(index, name) {
				this.weeklyReportForm[name].splice(index, 1);
			},
      confirmWeekly(loading) {
        this.$refs.weeklyReportForm.validate((valid) => {
					if (valid) {
            const { weeklyStartEndDate, thisWeekWorkProgressList, nextWeekWorkProgressList } = this.weeklyReportForm;
            let thisWeekWorkProgressListNew = [];
            thisWeekWorkProgressList.forEach(item=> {
              thisWeekWorkProgressListNew.push(item.jobContent)
            })
            let nextWeekWorkProgressListNew = [];
            nextWeekWorkProgressList.forEach(item=> {
              nextWeekWorkProgressListNew.push(item.jobContent)
            })
            let addresseeList = [];
            let ccList = [];
            if(this.recipientForm.address) {
              const splitData = this.recipientForm.address.split(';');
              addresseeList = splitData.filter(item => item.trim() !== '');
            }
            if(this.recipientForm.cc) {
              const splitCCData = this.recipientForm.cc.split(';');
              ccList = splitCCData.filter(item => item.trim() !== '');
            }
            let params = {
              ...this.weeklyReportForm,
              majorProjectId: this.id,
					    islhToken: sessionStorage.getItem('islhtoken'),
              reportStartDate: moment(weeklyStartEndDate[0]).format('YYYY-MM-DD'),
              reportEndDate: moment(weeklyStartEndDate[1]).format('YYYY-MM-DD'),
              thisWeekWorkProgressList: thisWeekWorkProgressListNew,
              nextWeekWorkProgressList: nextWeekWorkProgressListNew,
              addresseeList,
              ccList,
            }
						let url =`${this.$store.state.islhurl}majorProjectWeeklyReport/edit`;
            if(loading === 'sendLoading'){
              url =`${this.$store.state.islhurl}majorProjectWeeklyReport/sendReport`;
            }
						this[loading] = true;
						this._post(url, params).then(
							res => {
                this[loading] = false;
								if(res.code === 200) {
									this.$Message.success('Successful!' );
                  this.getWeeklyInfo();
                  if(loading === 'sendLoading'){
                    this.recipientModal = false;
                  }
								} else {
									this.$message.error(res.message || 'Failed!' );
								}
							}
						)
					}
				});
      },
      openHistoryDialog() {
        this.$refs.historyDialog.historyDialog = true;
        this.$refs.historyDialog.handleSearch();
      },
      openRecipientDialog() {
        this.$refs.weeklyReportForm.validate((valid) => {
					if (valid) {
            this.ensureProtectedCC();
            this.recipientModal = true;
          }
        })
      },
      closeRecipientDialog() {
        this.recipientModal = false;
        this.recipientForm = {
          address: this.addressData ? this.addressData.join(';') : '',
          cc: this.ccData ? this.ccData.join(';') : '',
        }
      },
      clearInfo(type) {
        this.recipientForm[type] = '';
        if (type === 'cc') {
          this.recipientForm.cc = this.fixedCcList.join(';');
        }
      },
      ensureProtectedCC() {
        let ccList = this.recipientForm.cc ? this.recipientForm.cc.split(';').filter(item => item.trim() !== '') : [];
        let updated = false;
        this.fixedCcList.forEach(email => {
          if (!ccList.includes(email)) {
            ccList.push(email);
            updated = true;
          }
        });
        if (updated) {
          this.recipientForm.cc = ccList.join(';');
          this.ccData = ccList;
        }
      },
      sendWeekly() {
         this.$refs.recipientForm.validate((valid) => {
					if (valid) {
            this.confirmWeekly('sendLoading');
          }
        })
      },
      openUserDialog(type) {
        this.userDialog = true;
        this.userChoosedType = type;
        // recipientForm: {
        //   address: '',
        //   cc: '',
        // },
        if (type === 1 && this.recipientForm.address !== '') {
          this.choosedUserList = this.recipientForm.address.split(';')
        } else if (type === 2 && this.recipientForm.cc !== '') {
          this.choosedUserList = this.recipientForm.cc.split(';')
        } else {
          this.choosedUserList = [];
        }
				this.handleUserSearch('btn');
      },
      handleUserSearch(type) {
        if (type === 'btn') {
          this.userPageSize = 5;
          this.userCurrentPage = 1;
        }
				this.tableLoading = true;
				let url =`${this.$store.state.islhurl}account/email/list?param=${this.searchUserWord}&&pageSize=${this.userPageSize}&&currentPage=${this.userCurrentPage}`
				this._get(url).then(
					res => {
						this.tableLoading = false;
						if(res.code === 200) {
              let newData = [];
							res.data.forEach((item, index) => {
								newData.push({
									...item,
									number: index + 1,
								})
							});
						  this.userTableData = newData;
						  this.userTotalCount = res.totalSize;
						} else {
							this.userTableData = [];
							this.$message.error(res.message || 'Failed!' );
						}
					}
				)
      },
			changeUserPageSize(size) {
				this.userPageSize = size;
				this.handleUserSearch();
			},
			changeUserPage(current) {
				this.userCurrentPage = current;
				this.handleUserSearch();
			},
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      transferToChoosed() {
        // 合并并去重（只保留不重复的项）
        this.choosedUserList = this.choosedUserList.concat(
          this.multipleSelection
            .map(a => a.email)  // 先提取所有email
            .filter(email => !this.choosedUserList.includes(email))  // 过滤掉已存在的email
        );
        this.multipleSelection = []
      },
      closeUserDialog() {
        this.userDialog = false;
        this.searchUserWord = '';
      },
      // 上移
      moveUp() {
        const index = this.choosedUserList.findIndex(item => item === this.selectedUserEmail);
        if (!this.selectedUserEmail || index === 0) return;
        
        const newList = [...this.choosedUserList];
        // 交换当前项和前一项
        [newList[index], newList[index - 1]] = [newList[index - 1], newList[index]];
        this.choosedUserList = newList;
      },
      // 下移
      moveDown() {
        const index = this.choosedUserList.findIndex(item => item === this.selectedUserEmail);
        if (!this.selectedUserEmail || index === this.choosedUserList.length - 1) return;
        
        const newList = [...this.choosedUserList];
        // 交换当前项和后一项
        [newList[index], newList[index + 1]] = [newList[index + 1], newList[index]];
        this.choosedUserList = newList;
      },
      deleteItem(index, email) {
        if (this.fixedCcList.includes(email)) {
          this.$message.error(`${email} cannot be deleted.`);
          return;
        }
        const newList = [...this.choosedUserList];
        newList.splice(index, 1); // 删除当前项
        this.choosedUserList = newList;
        if (email === this.selectedUserEmail) this.selectedUserEmail = null; // 清空选中状态
      },
      submitChoosedUser() {
        const userString = this.choosedUserList.join(';');
        if (this.userChoosedType === 1) {
          this.recipientForm.address = userString;
        } else {
          this.recipientForm.cc = userString;
        }
        this.userDialog = false;
        this.selectedUserEmail = null;
        this.choosedUserList = [];
      },
    },
  }
</script>
<style lang="less" scoped>
#weeklyReport {
  .redbg /deep/.el-input__inner {
    background: #FF0000;
  }
  .yellowbg /deep/.el-input__inner {
    background: #FFFF00;
  }
  .greenbg /deep/.el-input__inner {
    background: #92D050;
  }
	.el-form {
		padding: 0 0 20px 0;
		/deep/.el-input {
			max-width: 350px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 12px;
		}
		/deep/.el-input-number {
			width: 100%;
			.el-input__inner {
				text-align: left;
			}
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
			max-width: 350px;
		}
    /deep/.el-date-editor .el-range__icon {
      line-height: 26px;
    }
    .hasStar span {
      color: #F56C6C;
      padding-left: 1px;
    }
    .week-table {
      /deep/td.el-table__cell {
        padding: 20px 0 0 0;
      }
      /deep/.el-form-item {
        margin-bottom: 20px;
      }
    }
	}
  .recipientForm /deep/.el-form-item__label  {
    text-align: left;
  }
  .user-dialog {
    .el-table {
      height: 241px;
    }
    .transicon {
      width: 40px;
      height: 40px;
      border: 1px solid #ccc;
      border-radius: 5px;
      line-height: 40px;
      text-align: center;
      background: rgba(226, 226, 226, 0.3);
      margin-top: 100px;
      margin-left: 10px;
      cursor: pointer;
    }
    .choosed-user-wrap {
      width: 100%;
      height: 300px;
      margin-left: 12px;
      overflow-y: auto;
      border: 1px solid #ccc;
      border-radius: 5px;
      >div {
        display: flex;
        align-items: center;
        height: 28px;
        padding: 0px 7px 0 3px;
        p {
          flex: 1;
          line-height: 24px;
          padding: 0 5px;
          height: 24px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          color: #333;
          cursor: default;
        }
        i {
          cursor: pointer;
          font-size: 18px;
        }
        i:hover {
          color: #409EFF;
        }
      }
      .selected {
        background-color: #ccc;
        color: #000;
      }
    }
    .choosed-user-move {
      padding-top: 95px;
      margin-left: 24px;
      span {
        display: block;
        width: 80px;
        border: 1px solid #ccc;
        border-radius: 5px;
        line-height: 30px;
        text-align: center;
        background: rgba(226, 226, 226, 0.3);
        margin-bottom: 10px;
        cursor: pointer;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/major/weeklyReport/index.vue